import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BankProgressBarService } from '@core/components/progress-bar/progress-bar.service';
@Component({
    selector: 'bank-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankProgressBarComponent implements OnInit, OnDestroy, AfterViewChecked {
    bufferValue: number;
    mode: 'determinate' | 'indeterminate' | 'buffer' | 'query';
    value: number;
    visible: boolean;
    // Private
    private _unsubscribePrgrss: Subject<void> = new Subject();
    /**
     * Constructor
     *
     * @param {BankProgressBarService} _bankProgressBarService
     */
    constructor(
        private _bankProgressBarService: BankProgressBarService,
        private _cRef: ChangeDetectorRef
    ) {
        // Set the defaults
        // Set the private defaults
        this._unsubscribePrgrss = new Subject();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the progress bar service properties
        // Buffer value
        this._bankProgressBarService.bufferValue
            .pipe(takeUntil(this._unsubscribePrgrss))
            .subscribe((bufferValue) => {
                this.bufferValue = bufferValue;
            });
        // Mode
        this._bankProgressBarService.mode
            .pipe(takeUntil(this._unsubscribePrgrss))
            .subscribe((mode) => {
                this.mode = mode;
            });
        // Value
        this._bankProgressBarService.value
            .pipe(takeUntil(this._unsubscribePrgrss))
            .subscribe((value) => {
                this.value = value;
            });
        // Visible
        this._bankProgressBarService.visible
            .pipe(takeUntil(this._unsubscribePrgrss))
            .subscribe((visible) => {
                this.visible = visible;
            });
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribePrgrss.next();
        this._unsubscribePrgrss.complete();
    }
    ngAfterViewChecked() {
        this._cRef.detectChanges();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
}
